import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-weather-icons',
	templateUrl:'./WeatherIconsPluginPage.html',
	styles: [],
	styleUrls:['./WeatherIconsPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WeatherIconsPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_685 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>weather-icons</artifactId>
</dependency>
\`\`\``;
	mdContent_686 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:weather-icons")
\`\`\``;
	mdContent_687 = `\`\`\`java
var sunny = new WeatherIcons<>(WeatherIcon.day_sunny);
var rain = new WeatherIcons<>(WeatherIcon.rain);
var wind = new WeatherIcons<>(WeatherIcon.towards_n);
\`\`\``;
	mdContent_688 = `\`\`\`java
// Create a weather icon
var icon = new WeatherIcons<>(WeatherIcon.day_sunny);

// Night conditions
var night = new WeatherIcons<>(WeatherIcon.night_clear);

// Wind direction
var wind = new WeatherIcons<>(WeatherIcon.towards_n);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
